import React from 'react';

const SelectionInput = ({
  label,
  placeholder,
  value,
  onSearch,
  onSelect,
  onClear,
  results,
  isActive,
  onFocus,
  magazineSurveyList,
}) => {
  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div className="relative">
        <div className="flex items-center border rounded">
          <input
            type="text"
            className="form-control border-0"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onSearch(e.target.value)}
            onFocus={onFocus}
          />
          {value && (
            <button
              className="btn btn-link text-secondary p-2"
              onClick={onClear}
              type="button"
              aria-label="Clear selection"
            >
              {/* <X size={18} /> */}
            </button>
          )}
        </div>

        {isActive && results?.length > 0 && (
          <div className="absolute w-full mt-1 bg-white border rounded shadow-lg z-10 max-h-60 overflow-y-auto">
            {!magazineSurveyList
              ? results.map((item) => (
                  <div
                    key={item._id}
                    className="p-3 hover:bg-gray-100"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelect(item)}
                  >
                    <h6 className="mb-0 text-primary">{item.title}</h6>
                  </div>
                ))
              : results
                  .filter(
                    (item) =>
                      !magazineSurveyList.some(
                        (survey) => survey?.surveyId?._id === item?._id
                      )
                  )
                  .map((filteredItem) => (
                    <div
                      key={filteredItem?._id}
                      className="p-3 hover:bg-gray-100"
                      style={{ cursor: "pointer" }}
                      onClick={() => onSelect(filteredItem)}
                    >
                      <h6 className="mb-0 text-primary">
                        {filteredItem?.title ? filteredItem?.title : "No title"}
                      </h6>
                    </div>
                  ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectionInput; 